
  import { defineComponent, ref, toRefs } from 'vue';
  import { SelectOption } from '@/ui/types';
  import { TagField } from '@/ui/components/form/TagField';
  import { ChooseScheduleFieldProps } from '@/ui/components/schedule/chooseScheduleFieldProps';
  import CreateScheduleModal from '@/ui/components/schedule/CreateScheduleModal.vue';
  import { Icon } from '../icon/Icon';

  export default defineComponent<ChooseScheduleFieldProps>({
    name: 'ChooseScheduleField',
    components: {
      CreateScheduleModal,
      TagField,
      Icon,
    },
    props: [
      'options',
      'value',
      'errors',
      'label',
      'placeholder',
      'identifier',
      'hideLabel',
      'name',
      'maxListedOptions',
      'required',
      'disabled',
      'selectAllEnabled',
      'deselectAllEnabled',
    ],
    setup(props, context) {
      const {
        options,
        value,
        errors,
        required,
        disabled,
        selectAllEnabled,
        deselectAllEnabled,
      } = toRefs(props);

      const emitChange = (value: string[] | number[]) => {
        context.emit('input', value);
      };

      const emitSelectALl = () => {
        const allSchedules = options.value.map((schedule: SelectOption<number | string>) => schedule.value);
        context.emit('input', allSchedules);
      };

      const emitDeselectAll = () => {
        context.emit('input', []);
      };

      const isCreateScheduleModalOpen = ref(false);

      const onCreateScheduleClick = () => {
        isCreateScheduleModalOpen.value = true;
      };

      const onModalCLose = () => {
        isCreateScheduleModalOpen.value = false;
      };

      const onScheduleCreated = () => {
        isCreateScheduleModalOpen.value = false;
      };

      return {
        fieldOptions: options,
        fieldValue: value,
        fieldErrors: errors,
        fieldLabel: props.label,
        fieldPlaceholder: props.placeholder,
        fieldIdentifier: props.identifier,
        fieldHideLabel: props.hideLabel,
        fieldName: props.name,
        fieldRequired: required,
        fieldDisabled: disabled,
        selectAllFieldEnabled: selectAllEnabled,
        deselectAllFieldEnabled: deselectAllEnabled,
        fieldMaxListedOptions: props.maxListedOptions,
        isCreateScheduleModalOpen,
        emitChange,
        emitSelectALl,
        emitDeselectAll,
        onModalCLose,
        onCreateScheduleClick,
        onScheduleCreated,
      };
    },
  });
